const app = {
  pathToLibsFiles: './assets/libs',
};
window.app = app;

// polyfills
// before polyfills
(function (arr) {
  arr.forEach((item) => {
    if (item.hasOwnProperty('before')) {
      return;
    }
    Object.defineProperty(item, 'before', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function before() {
        // eslint-disable-next-line prefer-rest-params
        const argArr = Array.prototype.slice.call(arguments);
        const docFrag = document.createDocumentFragment();
        argArr.forEach((argItem) => {
          const isNode = argItem instanceof Node;
          docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
        });
        this.parentNode.insertBefore(docFrag, this);
      },
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// forEach polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    // eslint-disable-next-line no-param-reassign
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

const preLoader = () => {
  const mask = document.querySelector('.mask');
  const loader = document.querySelector('.loader');

  // setTimeout(() => {
  //   loader.style.width = '25%';
  // }, 300);

  // setTimeout(() => {
  //   loader.style.width = '50%';
  // }, 500);

  // setTimeout(() => {
  //   loader.style.width = '75%';
  // }, 700);

  window.addEventListener('load', () => {
    if (loader) {
      loader.style.width = '100%';
      setTimeout(() => {
        mask.style.display = 'none';
      }, 1000);
    }
  });
};

preLoader();

const toggleMenu = () => {
  const headerMenu = document.querySelector('.header-menu');
  const header = document.querySelector('.header');
  const menu = document.getElementById('menu');
  const headerLinks = document.querySelectorAll('.header-links');
  const logoImg = document.querySelector('.logo-img');
  const menuSymbolBtn = document.querySelector('.menu-symbol-btn');
  const menuTitleBtn = document.querySelector('.menu-title-btn');

  const openMenu = () => {
    setTimeout(() => {
      logoImg.src = '/assets/images/menu-logo.svg';
      menuSymbolBtn.textContent = '-';
      menuTitleBtn.textContent = menuTitleBtn.dataset.openMenu;
      document.querySelector('html').style.overflow = 'hidden';
    }, 500);
    headerMenu.classList.add('visible');
    headerLinks.forEach((item) => item.classList.add('visible'));
  };

  const closeMenu = () => {
    if (logoImg.classList.contains('img-black')) {
      logoImg.src = '/assets/images/menu-logo.svg';
    } else {
      logoImg.src = '/assets/images/logo.svg';
    }

    headerMenu.classList.remove('visible');
    headerLinks.forEach((item) => item.classList.remove('visible'));
    menuSymbolBtn.textContent = '+';
    menuTitleBtn.textContent = menuTitleBtn.dataset.closeMenu;
    document.querySelector('html').style.overflow = 'visible';
  };

  header.addEventListener('click', (e) => {
    if (e.target.closest('.header-menu')) {
      menu.classList.toggle('visible');
      if (menu.classList.contains('visible')) {
        openMenu();
      } else {
        closeMenu();
      }
    }
  });
};

toggleMenu();

const footerHover = () => {
  const footerLink = document.querySelector('.footer-link');
  const footer = document.querySelector('.footer');
  const icon = document.querySelector('.fa-heart');
  const bw = document.body.clientWidth;

  if (bw > 1200) {
    footerLink.addEventListener('mouseover', () => {
      footer.style.backgroundColor = '#c81947';
      icon.style.color = '#fff';
    });
    footerLink.addEventListener('mouseout', () => {
      footer.style.backgroundColor = '#0f0d0e';
      icon.style.color = '#c81947';
    });
  }
};

footerHover();

const toggleOrderPopup = () => {
  const headerOrder = document.querySelector('.header-order');
  const orderPopup = document.querySelector('.order-popup');
  const closeOrderPopup = document.querySelector('.close-order-popup');
  const orderPopupContent = document.querySelector('.order-popup-content');
  const moldingBtn = document.querySelector('.molding-btn');
  const goodsItemImg = document.querySelectorAll('.goods-item__img');
  const goodItemTitle = document.querySelectorAll('.good-item__title');
  const orderPopupSuccess = document.querySelector('.order-popup-success');
  const serviceAdvBtn = document.querySelector('.service-adv__btn');
  const duplicateDescriptionBtn = document.querySelector('.duplicate-description__btn');
  const duplicateTabBtn = document.querySelector('.duplicate-tab__btn');
  const contentItemSubtitleLink = document.querySelector('.content-item__subtitle-link');
  const input = document.querySelector('input[name="product"]');
  const orderPopupTitle = document.querySelector('.order-popup-title');
  const closeOrderPopupSubmit = document.querySelector('.close-order-popup__submit');

  const count = 0;
  let popupInterval;
  const currentLoc = window.location;

  const popupAnimate = () => {
    popupInterval = requestAnimationFrame(popupAnimate);
    orderPopupContent.style.right = count;
    if (count === 0) {
      cancelAnimationFrame(popupInterval);
    }
  };

  const openOrderPopup = () => {
    orderPopup.style.display = 'block';
    popupInterval = requestAnimationFrame(popupAnimate);
    document.querySelector('html').style.overflow = 'hidden';
  };

  if (goodsItemImg) {
    goodsItemImg.forEach((item) => {
      item.addEventListener('click', () => {
        input.value = item.dataset.title;
        openOrderPopup();
        orderPopupTitle.textContent = orderPopupTitle.dataset.formTitle;
      });
    });
  }

  if (goodItemTitle) {
    goodItemTitle.forEach((item) => {
      item.addEventListener('click', (e) => {
        input.value = e.target.dataset.title;
        openOrderPopup();
        orderPopupTitle.textContent = orderPopupTitle.dataset.formTitle;
      });
    });
  }

  if (moldingBtn) {
    moldingBtn.addEventListener('click', () => {
      openOrderPopup();
      input.value = moldingBtn.dataset.formTitle;
      orderPopupTitle.textContent = orderPopupTitle.dataset.formTitle;
    });
  }

  if (contentItemSubtitleLink) {
    contentItemSubtitleLink.addEventListener('click', () => {
      openOrderPopup();
    });
  }

  if (duplicateTabBtn) {
    duplicateTabBtn.addEventListener('click', () => {
      openOrderPopup();
      input.value = duplicateTabBtn.dataset.formTitle;
      orderPopupTitle.textContent = orderPopupTitle.dataset.formTitle;
    });
  }

  if (duplicateDescriptionBtn) {
    duplicateDescriptionBtn.addEventListener('click', () => {
      openOrderPopup();
      orderPopupTitle.textContent = orderPopupTitle.dataset.formTitle;
      input.value = duplicateDescriptionBtn.dataset.formTitle;
    });
  }

  if (serviceAdvBtn) {
    serviceAdvBtn.addEventListener('click', () => {
      openOrderPopup();
      if (currentLoc.pathname.includes('/cutting')) {
        input.value = serviceAdvBtn.dataset.formCuttingtitle;
      } else {
        input.value = serviceAdvBtn.dataset.formTitle;
      }
    });
  }

  headerOrder.addEventListener('click', () => {
    openOrderPopup();
    orderPopupTitle.textContent = orderPopupTitle.dataset.formTitle;
  });

  closeOrderPopup.addEventListener('click', () => {
    orderPopup.style.display = 'none';
    orderPopupContent.removeAttribute('style');
    document.querySelector('html').style.overflow = 'visible';
    orderPopupSuccess.style.display = 'none';
    input.value = '';
    orderPopupTitle.textContent = '';
  });

  closeOrderPopupSubmit.addEventListener('click', () => {
    orderPopup.style.display = 'none';
    orderPopupContent.removeAttribute('style');
    document.querySelector('html').style.overflow = 'visible';
    orderPopupSuccess.style.display = 'none';
    input.value = '';
    orderPopupTitle.textContent = '';
  });
};

toggleOrderPopup();

const toggleTablePopup = () => {
  const tablePopup = document.querySelectorAll('.table-popup');
  const goodsItemTable = document.querySelectorAll('.goods-item__table');
  const goods = document.querySelector('.goods');

  // const openTable = (index) => {
  //   for (let i = 0; i <= tablePopup.length; i++) {
  //     if (index === i) {
  //       tablePopup[i].style.display = 'block';
  //     }
  //   }
  // }

  if (goods) {
    goods.addEventListener('click', (e) => {
      /* eslint-disable-next-line */
      const target = e.target;

      goodsItemTable.forEach((item) => {
        if (target === item) {
          tablePopup.forEach((tableItem) => {
            /* eslint-disable-next-line */
            if (tableItem.id === item.dataset.id) {
              /* eslint-disable-next-line */
              tableItem.style.display = 'block';
            }
          });
        }
      });
    });
  }

  if (tablePopup) {
    tablePopup.forEach((item) => {
      item.addEventListener('click', (e) => {
        if (e.target.closest('.close-table-popup')) {
          /* eslint-disable-next-line */
          item.style.display = 'none';
        }
      });
    });
  }
};

toggleTablePopup();

const animations = () => {
  const bw = document.body.clientWidth;

  gsap.registerPlugin(ScrollTrigger);
  gsap.defaults({
    ease: 'none',
  });

  const white = document.querySelectorAll('.white');
  const black = document.querySelectorAll('.black');
  const test = document.querySelector('.test');
  const goods = document.querySelector('.foam-goods');
  const aboutCollection = document.querySelector('.about-collection');
  const aboutCompanyDescription = document.querySelector('.about-company-description');
  // const panel = document.querySelectorAll('.panel');
  white.forEach((item) => {
    ScrollTrigger.create({
      trigger: (item),
      start: 'top 120px',
      end: 'top 120px',
      onEnter: () => {
        $('.header-links').addClass('header-links-black');
        $('.header-menu').addClass('btn-black');
        document.querySelector('.logo-img').src = '/assets/images/menu-logo.svg';
      },
      onEnterBack: () => {
        $('.header-links').removeClass('header-links-black');
        $('.header-menu').removeClass('btn-black');
        document.querySelector('.logo-img').src = '/assets/images/logo.svg';
      },
    });
  });

  black.forEach((item) => {
    ScrollTrigger.create({
      trigger: (item),
      start: 'top 120px',
      end: 'top 120px',
      onEnter: () => {
        $('.header-links').removeClass('header-links-black');
        $('.header-links-black').addClass('header-links');
        $('.header-menu').removeClass('btn-black');
        document.querySelector('.logo-img').src = '/assets/images/logo.svg';
      },
      onEnterBack: () => {
        $('.header-links').addClass('header-links-black');
        $('.header-menu').addClass('btn-black');
        document.querySelector('.logo-img').src = '/assets/images/menu-logo.svg';
      },
    });
  });

  if (test) {
    ScrollTrigger.create({
      trigger: (test),
      start: 'top 120px',
      end: 'top 120px',
      onEnter: () => {
        $('.header-links').addClass('header-links-black');
        $('.header-menu').addClass('btn-black');
        document.querySelector('.logo-img').src = '/assets/images/menu-logo.svg';
      },
      onEnterBack: () => {
        $('.header-links').removeClass('header-links-black');
        $('.header-menu').removeClass('btn-black');
        document.querySelector('.logo-img').src = '/assets/images/logo.svg';
      },
    });
  }

  // ScrollTrigger.create({
  //   trigger: '.hidden-header',
  //   start: 'top 120px',
  //   end: 'top 120px',
  //   onEnter: () => {
  //     $('.header-wht').addClass('hidden');
  //   },
  //   onEnterBack: () => {
  //     $('.header-wht').removeClass('hidden');
  //   },
  // });

  if (bw > 1024) {
    /* eslint-disable-next-line */
    $('.container-animate').map((index, element) => {
      gsap.to($(element), {
        scrollTrigger: {
          trigger: $(element),
          start: 'top bottom',
          end: '50% 50%',
          scrub: 1,
        },
        opacity: 1,
      });
    });

    /* eslint-disable-next-line */
    $('.container-animate-wrapper').map((index, element) => {
      gsap.to($(element), {
        scrollTrigger: {
          trigger: $(element),
          start: '50% top',
          end: 'bottom top',
          scrub: 1,
        },
        opacity: 0,
      });
    });

    gsap.to($('.about-company__img-block')[0], {
      scrollTrigger: {
        trigger: $('.about-company .container-animate'),
        start: 'top bottom',
        end: '50% 50%',
        scrub: 1,
      },
      translateY: 0,
    });

    gsap.utils.toArray('.panel').forEach((panel) => {
      ScrollTrigger.create({
        trigger: panel,
        start: 'top top',
        pin: true,
        pinSpacing: false,
      });
    });

    if (aboutCollection) {
      ScrollTrigger.create({
        trigger: (aboutCollection),
        start: 'top 120px',
        end: 'top 120px',
        onEnter: () => {
          $('#header').removeClass('bg');
          $('#header').removeClass('bg');
        },
        onEnterBack: () => {
          $('#header').addClass('bg');
          $('#header').addClass('bg');
        },
      });
    }

    if (goods) {
      ScrollTrigger.create({
        trigger: (goods),
        start: 'top 120px',
        end: 'top 120px',
        onEnter: () => {
          $('#header').addClass('bg');
          $('#header').addClass('bg');
        },
        onEnterBack: () => {
          $('#header').removeClass('bg');
          $('#header').removeClass('bg');
        },
      });
    }

    if (aboutCompanyDescription) {
      ScrollTrigger.create({
        trigger: (aboutCompanyDescription),
        start: 'top 120px',
        end: 'top 120px',
        onEnter: () => {
          $('#header').addClass('bg');
          $('#header').addClass('bg');
        },
        onEnterBack: () => {
          $('#header').removeClass('bg');
          $('#header').removeClass('bg');
        },
      });
    }
  }
};

window.onload = function () {
  ScrollTrigger.refresh();

  const pictureObserver = lozad('.lozad', {
    threshold: 0.1,
  });

  pictureObserver.observe();
};

animations();

const slider = () => {
  /* eslint-disable-next-line */
  const swiper = new Swiper('.swiper', {
    slidesPerView: 4.5,
    breakpoints: {
      320: {
        spaceBetween: 10,
        slidesPerView: 2,
      },
      577: {
        spaceBetween: 16,
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      768: {
        spaceBetween: 30,
        slidesPerView: 3,
      },
      1201: {
        spaceBetween: 65,
        slidesPerView: 4,
      },
    },
  });
};

slider();

const footerSlider = () => {
  /* eslint-disable-next-line */
  let possibilitiesSlider;
  /* eslint-disable-next-line */
  possibilitiesSlider = new Swiper('.footer-slider', {
    slidesPerView: 6,
    slidesPerGroup: 6,
    spaceBetween: 20,
    breakpoints: {
      320: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 20,
      },
      440: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 20,
      },
      576: {
        slidesPerView: 6,
        slidesPerGroup: 6,
        spaceBetween: 20,
      },
    },
  });
};

footerSlider();

// function maskPhone(selector, masked = '+375 (__) ___-__-__') {
//   const elems = document.querySelectorAll(selector);

//   function mask(event) {
//     /* eslint-disable-next-line */
//     const keyCode = event.keyCode;
//     const template = masked;
//     const def = template.replace(/\D/g, '');
//     const val = this.value.replace(/\D/g, '');
//     let i = 0;
//     /* eslint-disable-next-line */
//     let newValue = template.replace
//     (/[_\d]/g, a => (i < val.length ? val.charAt(i++) || def.charAt(i) : a));
//     i = newValue.indexOf('_');
//     if (i !== -1) {
//       newValue = newValue.slice(0, i);
//     }
//     /* eslint-disable-next-line */
//     let reg = template.substr(0, this.value.length)
//      .replace(/_+/g, a => '\\d{1,' + a.length + '}').replace(/[+()]/g, '\\$&');
//     /* eslint-disable-next-line */
//     reg = new RegExp('^' + reg + '$');
//     /* eslint-disable-next-line */
//     if (!reg.test(this.value) || this.value.length < 5 || keyCode > 47 && keyCode < 58) {
//       this.value = newValue;
//     }
//     if (event.type === 'blur' && this.value.length < 5) {
//       this.value = '';
//     }
//   }
//   /* eslint-disable-next-line */
//   for (const elem of elems) {
//     elem.addEventListener('input', mask);
//     elem.addEventListener('focus', mask);
//     elem.addEventListener('blur', mask);
//   }
// }

// // use

// maskPhone('input[name="phone"]');

const validationForm = () => {
  const orderPopupForm = document.querySelector('.order-popup-form');

  orderPopupForm.addEventListener('input', (e) => {
    if (e.target.matches('input[name="name"]')) {
      if (e.target.value.length <= 20) {
        e.target.value = e.target.value.replace(/[^\D]/, '');
      } else {
        e.target.value = '';
      }
    }

    if (e.target.matches('input[name="email"]')) {
      if (e.target.value.length >= 50) {
        e.target.value = '';
      } else {
        /* eslint-disable-next-line */
        e.target.value = e.target.value.replace(/[А-яЁё]/, '');
      }
    }

    if (e.target.matches('input[name="phone"]')) {
      if (e.target.value.length >= 30) {
        e.target.value = '';
      } else {
        /* eslint-disable-next-line */
        e.target.value = e.target.value.replace(/[^+?][^(0-9)\s]/g, '');
      }
    }

    if (e.target.matches('input[name="product"]')) {
      if (e.target.value.length <= 30) {
        e.target.value = e.target.value.replace(/[^\D]/, '');
      } else {
        e.target.value = '';
      }
    }

    if (e.target.matches('input[name="message"]')) {
      if (e.target.value.length >= 500) {
        e.target.value = '';
      }
    }
  });
};

validationForm();

// const submitBtn = () => {
//   const orderPopupBtn = document.querySelector('.order-popup__btn');
//   const orderPopupSuccess = document.querySelector('.order-popup-success');
//   const closeOrderPopupSubmit = document.querySelector('.close-order-popup__submit');
//   const orderPopup = document.querySelector('.order-popup');

//   orderPopupBtn.addEventListener('click', () => {
//     orderPopupSuccess.style.display = 'block';
//   });

//   closeOrderPopupSubmit.addEventListener('click', () => {
//     orderPopup.style.display = 'none';
//     orderPopupSuccess.style.display = 'none';
//     document.querySelector('html').style.overflow = 'visible';
//   });
// };

// submitBtn();

const goodsHover = () => {
  const goods = document.querySelector('.goods');
  const backdrop = document.querySelector('.backdrop');
  const bw = document.body.clientWidth;

  if (goods) {
    if (bw > 1050) {
      goods.addEventListener('mouseover', (e) => {
        if (e.target.closest('.goods-item')) {
          const target = e.target.closest('.goods-item');
          backdrop.classList.add('active');
          target.classList.add('active');
        }
      });

      goods.addEventListener('mouseout', (e) => {
        if (e.target.closest('.goods-item')) {
          const target = e.target.closest('.goods-item');
          backdrop.classList.remove('active');
          target.classList.remove('active');
        }
      });
    }
  }
};

goodsHover();

const duplicateSlider = () => {
  /* eslint-disable-next-line */
  const duplicatSlider = new Swiper('.duplicate-slider', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    speed: 600,
    loop: true,
    navigation: {
      nextEl: '.next',
      prevEl: '.prev',
    },
  });
};

duplicateSlider();

const toggleSubMenu = () => {
  const openHelpMenu = document.querySelector('.open-help-menu');
  const navLinkList = document.querySelector('.nav-link__list');

  openHelpMenu.addEventListener('click', () => {
    openHelpMenu.classList.toggle('active');
    navLinkList.classList.toggle('active');
  });
};

toggleSubMenu();

const hideText = () => {
  const str = document.querySelectorAll('.collection-item__text');

  str.forEach((item) => {
    const strContent = item.textContent;

    if (strContent.length > 300) {
      /* eslint-disable-next-line */
      const cutText = strContent.slice(0, 300) + '...';
      /* eslint-disable-next-line */
      item.textContent = cutText;
    }

    item.addEventListener('click', (e) => {
      const targetText = e.target.closest('.collection-item__text');

      if (item === targetText) {
        /* eslint-disable-next-line */
        if (strContent.length > 300) {
          /* eslint-disable-next-line */
          const cutText = strContent.slice(0, 1000);
          /* eslint-disable-next-line */
          item.textContent = cutText;
        }
      }
    });
  });
};

hideText();
